import { useEffect, useState } from 'react'
import {
  Easing,
  Extrapolation,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'

export const useCardBirthdayAnimation = () => {
  const [showCard, setShowCard] = useState(true)
  const toggleValue = useSharedValue(0)

  useEffect(() => {
    if (showCard) {
      toggleValue.value = withTiming(100, { duration: 250, easing: Easing.bezier(0.25, 0.1, 0.25, 1) })
    } else {
      toggleValue.value = withTiming(0, { duration: 250, easing: Easing.bezier(0.25, 0.1, 0.25, 1) })
    }
  }, [toggleValue, showCard])

  const prayTextStyle = useAnimatedStyle(() => ({
    maxHeight: interpolate(toggleValue.value, [0, 100], [0, 100], Extrapolation.CLAMP),
    opacity: interpolate(toggleValue.value, [80, 100], [0, 1], Extrapolation.CLAMP),
  }))

  const psalmTextStyle = useAnimatedStyle(() => ({
    maxHeight: interpolate(toggleValue.value, [0, 100], [0, 300], Extrapolation.CLAMP),
    opacity: interpolate(toggleValue.value, [0, 100], [0, 1], Extrapolation.CLAMP),
  }))

  return { showCard, setShowCard, prayTextStyle, psalmTextStyle }
}
